import { render, staticRenderFns } from "./NetWorth.vue?vue&type=template&id=bad87026&scoped=true&"
import script from "./NetWorth.vue?vue&type=script&lang=js&"
export * from "./NetWorth.vue?vue&type=script&lang=js&"
import style0 from "./NetWorth.vue?vue&type=style&index=0&id=bad87026&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad87026",
  null
  
)

export default component.exports